export default "__VITE_ASSET__B7n7y7nZ__"